import { Box, HStack, Text } from '@chakra-ui/react';
import React from 'react';
import TimelineItem from './TimelineItem/TImelineItem';
import { useEffect, useRef, useState } from 'react';

import './WeatherTimeline.scss';

export default function WeatherTimeline(props) {
  const [mergedData, setMergedData] = useState([]);
  const scrollRef = useRef(null);
  const {
    data,
    setMainConditions,
    selectedHour,
    setSelectedHour,
    hourlyWarnings,
    onWarningClick,
  } = props;

  useEffect(() => {
    if (data !== null) {
      setMergedData(data[0].hours.concat(data[1]?.hours || []));
    }
  }, [data]);

  useEffect(() => {
    if (mergedData && selectedHour !== null)
      setMainConditions(mergedData[selectedHour]);
  }, [selectedHour, mergedData, setMainConditions]);

  // Horizontally center the selected hour (the passing-time hour) in the
  // timeline so it is visible without manual scrolling.
  useEffect(() => {
    const container = scrollRef.current;
    if (!container || selectedHour == null || mergedData.length === 0) return;
    const child = container.children[selectedHour];
    if (!child) return;
    const containerRect = container.getBoundingClientRect();
    const childRect = child.getBoundingClientRect();
    const delta =
      childRect.left -
      containerRect.left -
      (containerRect.width - childRect.width) / 2;
    container.scrollTo({ left: container.scrollLeft + delta, behavior: 'smooth' });
  }, [selectedHour, mergedData]);

  return (
    <HStack
      ref={scrollRef}
      w="90%"
      p={3}
      className="horizontal-scrollbar"
      gap={3}
      bgColor="#d9d9d926"
      borderRadius={5}
      mt={10}
    >
      {data &&
        mergedData.map((item, index) => (
          <TimelineItem
            key={`${index}_${item.period}_${item.weatherCode}`}
            period={item.period}
            weatherCode={item.weatherCode}
            temperature={item.temperature}
            handleOnClick={() => {
              setSelectedHour(index);
            }}
            selected={selectedHour === index}
            warnings={hourlyWarnings?.[item.period] || []}
            onWarningClick={warning => {
              if (onWarningClick) {
                onWarningClick(warning, item.period);
              }
            }}
          />
        ))}
    </HStack>
  );
}
